import { Card, Heading } from "@icg360/design-system";

import { EmailIconLink, PhoneIconLink } from "components/common/link";
import { useFlags } from "utils";

import styles from "./support-sidebar.module.scss";

const availableHours = (
  <div className={styles.secondaryText}>
    <div>Monday - Friday: 8am - 9pm EST</div>
    <div>Saturday: 10am - 3pm EST</div>
  </div>
);

export const SupportSidebar = () => {
  const { supportPhoneNumber } = useFlags();
  const phone =
    typeof supportPhoneNumber === "string" ? supportPhoneNumber : "";

  return (
    <Card>
      <div className={styles.cardContent}>
        <Heading size="md">SageSure customer care</Heading>
        Customer care can assist with any questions about billing or your
        SageSure account.
        <div>
          <div className={styles.contactHeader}>
            <EmailIconLink email="customercare@sagesure.com" />
          </div>
          <span className={styles.secondaryText}>
            {"We'll reply within 48 hours."}
          </span>
        </div>
        <div>
          <div className={styles.contactHeader}>
            <PhoneIconLink phone={phone} />
          </div>
          {availableHours}
        </div>
      </div>
    </Card>
  );
};
